import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'subscriptionPeriodicity',
  standalone: false,
})
export class SubscriptionPeriodicityPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: unknown): string {
    return (
      this.translate.instant(`enums.subscriptionPeriodicity.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
